module.exports = __webpack_public_path__ + "img/23.62f44cd5.png";